// File: client/src/variant/cardEffects/index.js
//
// Central registration of every card effect (DESIGN PRINCIPLE #4: no switch —
// each effect is its own object; this file just wires them into the registry).
// Adding a new effect kind = add one import + one registerEffect line here. Cards
// that reuse an existing kind need no change at all.

import { registerEffect } from '../effectEngine';

import bonusMoves from './bonusMoves';
import skipOpponent from './skipOpponent';
import { reverse, tradeHands } from './turnFlow';
import { movementOverride, movementLimit, pawnRiot } from './movement';

let registered = false;

/**
 * Register all built-in effects exactly once (idempotent — safe to call from
 * multiple entry points / re-renders).
 */
export function registerAllEffects() {
  if (registered) return;
  [
    bonusMoves,
    skipOpponent,
    reverse,
    tradeHands,
    movementOverride,
    movementLimit,
    pawnRiot,
  ].forEach(registerEffect);
  registered = true;
}

/** Test helper: force re-registration after a registry reset. */
export function __forceReregister() {
  registered = false;
  registerAllEffects();
}
